import { render, staticRenderFns } from "./goods-info.vue?vue&type=template&id=cb89bef2&scoped=true"
import script from "./goods-info.vue?vue&type=script&lang=js"
export * from "./goods-info.vue?vue&type=script&lang=js"
import style0 from "./goods-info.vue?vue&type=style&index=0&id=cb89bef2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb89bef2",
  null
  
)

export default component.exports